import React from "react";
import {Navigate, useParams} from 'react-router-dom';
// import axios from 'axios';
import Menu from "../components/menu/Menu";
import ListCollectionFaces from "../components/list-collection-face/ListCollectionFaces";
import {Container} from 'react-bootstrap';
import Verify from "../components/verify/Verify"
// import { trackPromise } from 'react-promise-tracker';

const ListCollectionsFacesMain = () => {

    const params = useParams();
    var idcol = null;
    
    if(params){
        idcol = params.idcol
    }

    if(!sessionStorage.getItem('userData')){
        return <Navigate to="/"  />;
    }
    else{
        Verify()
    }
    
    return(
        <>
            <Menu />
            <Container>
                <ListCollectionFaces id={idcol} />
            </Container>
        </>
    )
};

export default ListCollectionsFacesMain;
